import { Controller } from '@hotwired/stimulus';
import {
  parseFormData,
  restructureVatData,
  postOnboardingData,
} from '../utils/onboarding_form_helpers';

// Contrôleur pour gérer l'édition des données d'onboarding
export default class extends Controller {
  static targets = ['form', 'modal'];
  static values = {
    sessionId: Number,
    section: String, // "project", "client", "contractor", "contract"
    index: Number, // Pour contractors et contracts
    contractorIndex: Number, // Pour le matching de contractor
  };

  // Ouvrir la modale d'édition
  openModal() {
    let modalId;
    if (this.hasIndexValue) {
      // Pour contractors et contracts, utiliser l'index
      modalId = `edit-${this.sectionValue}-${this.indexValue}-modal`;
    } else {
      // Pour project et client
      modalId = `edit-${this.sectionValue}-modal`;
    }

    const modal = document.getElementById(modalId);
    if (modal) {
      window.openModal(modalId);
    } else {
      console.error(`Modal ${modalId} not found`);
    }
  }

  // Soumettre le formulaire en AJAX
  async submit(event) {
    event.preventDefault();

    const form = event.target;
    const formData = new FormData(form);
    const data = parseFormData(formData, ['index']);

    // Pour les contracts, restructurer les données TVA dans vat_distribution
    if (this.sectionValue === 'contract') {
      restructureVatData(data);
    }

    try {
      const payload = {
        section: this.sectionValue,
        data: data,
      };

      // Ajouter l'index pour contractors et contracts
      if (this.hasIndexValue) {
        payload.index = this.indexValue;
      }

      await postOnboardingData(`/onboarding/${this.sessionIdValue}/update_data`, 'PATCH', payload);
    } catch (error) {
      console.error('Erreur lors de la mise à jour:', error);
      alert('Erreur lors de la mise à jour des données');
    }
  }

  // Annuler et fermer la modale
  cancel() {
    let modalId;
    if (this.hasIndexValue) {
      modalId = `edit-${this.sectionValue}-${this.indexValue}-modal`;
    } else {
      modalId = `edit-${this.sectionValue}-modal`;
    }
    window.closeModal(modalId);
  }

  // Sauvegarder le choix de matching (utiliser entreprise existante ou créer nouvelle)
  async saveMatchingChoice(event) {
    event.preventDefault();

    const radioName = `contractor_action_${this.contractorIndexValue}`;
    const selectedRadio = document.querySelector(`input[name="${radioName}"]:checked`);

    if (!selectedRadio) {
      alert('Veuillez sélectionner une option');
      return;
    }

    const action = selectedRadio.value; // "use_existing_123" ou "create_new"
    let contractorId = null;

    if (action.startsWith('use_existing_')) {
      contractorId = parseInt(action.split('_')[2]);
    }

    try {
      await postOnboardingData(`/onboarding/${this.sessionIdValue}/update_data`, 'PATCH', {
        section: 'contractor_matching',
        index: this.contractorIndexValue,
        data: {
          action: contractorId ? 'use_existing' : 'create_new',
          existing_contractor_id: contractorId,
        },
      });
    } catch (error) {
      console.error('Erreur lors de la sauvegarde du choix:', error);
      alert('Erreur lors de la sauvegarde');
    }
  }

  // Sauvegarder le choix de matching client (utiliser client existant ou créer nouveau)
  async saveClientMatchingChoice(event) {
    event.preventDefault();

    const selectedRadio = document.querySelector('input[name="client_action"]:checked');

    if (!selectedRadio) {
      alert('Veuillez sélectionner une option');
      return;
    }

    const action = selectedRadio.value; // "use_existing_123" ou "create_new"
    let clientId = null;

    if (action.startsWith('use_existing_')) {
      clientId = parseInt(action.split('_')[2]);
    }

    try {
      await postOnboardingData(`/onboarding/${this.sessionIdValue}/update_data`, 'PATCH', {
        section: 'client_matching',
        data: {
          action: clientId ? 'use_existing' : 'create_new',
          existing_client_id: clientId,
        },
      });
    } catch (error) {
      console.error('Erreur lors de la sauvegarde du choix client:', error);
      alert('Erreur lors de la sauvegarde');
    }
  }
}
